module.exports = __webpack_public_path__ + "img/communicationtest.011f111c.svg";